import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * Returns day & month for event badge using event timezone
 * @param {Object} event
 */
export const formatEventDateBadge = (event) => {
  const tz = event?.event_timezone || "UTC";

  if (!event?.start_date) {
    return { day: "-", month: "-" };
  }

  const date = dayjs.utc(event.start_date).tz(tz);

  if (!date.isValid()) {
    return { day: "-", month: "-" };
  }

  return {
    day: date.format("DD"),
    month: date.format("MMM"),
  };
};
